import React from "react";
import { toggleDrawerAction } from "../../../store/action/admin/themeActions";
import { TranslatorNavigationTag } from "../../../languageTranslator/LanguageTranslatorTags";
import { Card, Col, Menu, Typography } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { css } from "@emotion/css";
import ArrowRightIcon from "../../../Theme/CustomIcons/Icons/Arrow/ArrowRightIcon";
import ArrowLeft from "../../../Theme/CustomIcons/Icons/Arrow/ArrowLeft";
const { Text } = Typography;
function BoxListView({ subItem, current }) {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);

  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;
  let trimmedCurrent = current?.replace(/\/[a-zA-Z0-9]{5}$/, "");

  let isTrue =
    current === subItem?.key ||
    subItem?.siblings.includes(current) ||
    subItem?.siblings.includes(trimmedCurrent);
  const cardStyle1 = css`
    transition: border 0.1s ease-in-out, color 0.1s ease-in-out;
    box-shadow: none;
    height: clamp(25px, 3.6vw, 53px);
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: ${themeDefault?.info?.borderRadius}px;
    border: solid 1px
      ${isTrue
        ? themeDefault?.info?.colorPrimary
        : themeDefault?.info?.newConfig?.headerDrawerItemBorder}!important;
    cursor: pointer;
    // color: ${themeDefault?.info?.newConfig?.headerDrawerTextColor};
    color: ${isTrue
      ? `${themeDefault?.info?.colorPrimary}`
      : `${themeDefault?.info?.newConfig?.headerDrawerTextColor}`} !important;
    .icon {
      color: ${isTrue
        ? `${themeDefault?.info?.colorPrimary}`
        : `${themeDefault?.info?.newConfig?.headerDrawerTextColor}`} !important;
    }
    // background: ${themeDefault?.info?.newConfig?.cardBackground};
    // backdrop-filter: blur(${themeDefault?.info?.newConfig?.cardBlur});
    .icon {
      color: rgb(0 0 0 / 14%);
      transition: border 0.1s ease-in-out, color 0.1s ease-in-out;
    }
    .text {
      color: ${themeDefault?.info?.newConfig?.headerDrawerTextColor};
      transition: border 0.1s ease-in-out, color 0.1s ease-in-out;
    }
    :hover {
      border: solid 1px ${themeDefault?.info?.colorPrimary} !important;
      cursor: pointer;
      .icon {
        color: ${themeDefault?.info?.colorPrimary} !important;
      }
      color: ${themeDefault?.info?.colorPrimary} !important;
    }
  `;
  return (
    <Link to={subItem.link} onClick={() => dispatch(toggleDrawerAction(false))}>
      <div className={cardStyle1}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            alignContent: " center",
            justifyContent: "space-around",
            padding: "0 10px",
          }}
        >
          <div
            style={{
              padding: "0 5px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: "5px",
            }}
          >
            <div
              className={css`
                .anticon {
                  font-size: clamp(15px, 1.3vw, 20px) !important;
                }
              `}
            >
              {subItem.icon}
            </div>

            <p
              className={css`
                font-family: ${themeDefault?.info?.fontFamilyTitle} !important;
                font-size: clamp(8px, 1vw, 13px);
                font-weight: 400;
              `}
            >
              <TranslatorNavigationTag>{subItem.label}</TranslatorNavigationTag>
            </p>
          </div>
          <div
            className={css`
              .anticon {
                font-size: clamp(15px, 1.3vw, 20px) !important;
              }
            `}
          >
            {translations?.direction && translations?.direction === "rtl" ? (
              <ArrowLeft size="medium" />
            ) : translations?.direction && translations?.direction === "ltr" ? (
              <ArrowRightIcon size="medium" />
            ) : (
              <ArrowRightIcon size="medium" />
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}

export default BoxListView;
